import { render, staticRenderFns } from "./account_statements_main_resident.vue?vue&type=template&id=1f3f6902&scoped=true"
import script from "./account_statements_main_resident.vue?vue&type=script&lang=js"
export * from "./account_statements_main_resident.vue?vue&type=script&lang=js"
import style0 from "./account_statements_main_resident.vue?vue&type=style&index=0&id=1f3f6902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f6902",
  null
  
)

export default component.exports